import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import '../../types/shared/products.js';
import '../../events/event-properties-provider.js';
import { useDispatchTrackClickEvent } from '../../events/use-track-click-event.js';
import '../../events/use-track-error-event.js';

var TealiumLink = (_param)=>{
    var { tealiumEvent  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "tealiumEvent"
    ]);
    const { onClick  } = props, rest = swcHelpers.objectWithoutProperties(props, [
        "onClick"
    ]);
    const dispatchTrackClickEvent = useDispatchTrackClickEvent();
    const handleClick = (event)=>{
        if (tealiumEvent) {
            try {
                dispatchTrackClickEvent(swcHelpers.objectSpread({}, tealiumEvent));
            } catch (error) {
                // Log error but don't prevent onClick from being called
                console.error('Tealium dispatch error:', error);
            }
        }
        if (onClick) {
            onClick(event);
        }
    };
    return /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, rest, {
        onClick: handleClick
    }));
};

export { TealiumLink };
//# sourceMappingURL=TealiumLink.js.map
